import React, { Component } from "react";
import Page from "../../components/Page";

class Omgevingsvergunningen extends Component {
  render() {
    return (
      <Page title="Omgevingsvergunningen">
        <p>
          <img
            alt="Omgevingsvergunningen"
            src={
              process.env.PUBLIC_URL +
              "/images/themas/omgevingsvergunningen.jpg"
            }
            className="fullwidth shadow"
          />
        </p>
        <p>
          Vergunningsaanvragen moeten correct en vlot verlopen. Een goede
          verstandhouding met de provinciale vergunningverlenende overheid is
          belangrijk.
        </p>
      </Page>
    );
  }
}

export default Omgevingsvergunningen;
